import React, {useState} from 'react';
import AutoplaySwi from './AutoplaySwi';
import './Resume.css';

import { NavLink , useNavigate} from 'react-router-dom';



const Resume = () => {

    const navigate = useNavigate();
    
    const [user,setUser] = useState({
        name:"",
        email:"",
        phone:"",
        password:"",
        projects:"",
        skills:"",
        education:"",
        others:""

    });

    let name,value;

const handleInputs=(e)=>{
    
    name = e.target.name;
    value = e.target.value;

    setUser({ ...user, [name]:value})
}


const PostData = async (e) =>{
    e.preventDefault();
    const { name, email, phone, password, projects, skills, education, others } = user;

    const res = await fetch('/register', {
        method:"POST",
        headers:{
            "Content-Type" : "application/json"
        },
        body: JSON.stringify({
            name, email, phone, password , projects, skills, education, others
        })
    });

    const data = await res.json();

    if(data.status === 422 || !data){
        window.alert("Invalid Registration");
        console.log("invalid registration");
    }
    else{   
            window.alert('successful');
            navigate('/');
    }
}


  return (
    <>   
        <h1 id="resume-builder-online" className='resume_heading'>Resume Builder</h1>
        <div className="resume_container">
        <div className="resume_container_heading">We build Your Resume</div>
        <div className="resume_banner">
                <img src="image/Resume/Resume_img.webp" alt="" className="resume_img" />
            </div>
            <AutoplaySwi
                spl = "3"
                img1="image/Resume/ResumeTemplates/1.webp"
                img2="image/Resume/ResumeTemplates/2.webp"
                img3="image/Resume/ResumeTemplates/3.webp"
                img4="image/Resume/ResumeTemplates/4.webp"
                img5="image/Resume/ResumeTemplates/5.webp"
                img6="image/Resume/ResumeTemplates/6.webp"
            
            />

            <div className='resume_about_section'>
                        <div className=" resume_data">
                            <p>
                            <span>Don't spend</span> time on building Resume
                            </p>
                            <br/>
                            <p>
                            <span>Let us do this for you</span>
                            </p>
                            <p>Send us your details we Build Best Resumes for you</p>


                        </div>
            </div>
           
            <div className="tap_on_resume">
                      Tap on form to Open
            </div>

            <div className='resume_main_sign_box'>
                <div className="sign_page resume_sign_page">
                    <div className='sign_box resume_form_box'>
                        <div className = "resume_main_page">
                            <h2 className='resume_form_title'>DETAILS</h2>
                        
                                <div className="">
                                    {/* <img className="resume_form_img" src="" alt="" /> */}
                                </div>
                                


                            <form className="registration_form" id="registration_form" method="POST">
                    




                    <div className="form_group">
                        <label htmlFor="name">
                            {/* <i class="zmdi zmdi-account"></i> */}
                        </label>
                        <input type="text" className="resume_input_field" name="name" autoComplete='off'
                        value={user.name}
                        onChange={handleInputs}
                        placeholder='Enter your name'/>
                    </div>





                    <div className="form_group">
                        <label htmlFor="email">
                            {/* <i class="zmdi zmdi-email"></i> */}
                        </label>
                        <input type="email" className="resume_input_field" name="email" autoComplete='off'
                        value={user.email}
                        onChange={handleInputs}
                        placeholder='Enter your email'/>
                    </div>






                    <div className="form_group">
                        <label htmlFor="phone">
                            {/* <i class="zmdi zmdi-phone"></i> */}
                        </label>
                        <input type="number" className="resume_input_field" name="phone" autoComplete='off'
                        value={user.phone}
                        onChange={handleInputs}
                        placeholder='Enter your phone number'/>
                    </div>






                    <div className="form_group">
                        <label htmlFor="password">
                            {/* <i class="zmdi zmdi-lock"></i> */}
                        </label>
                        <textarea type="password" className="resume_input_field resume_textarea" name="password" autoComplete='off'
                        value={user.password}
                        onChange={handleInputs}
                        placeholder='Enter your Work Experience'/>
                    </div>



                    <div className="form_group">
                        <label htmlFor="projects">
                            {/* <i class="zmdi zmdi-lock"></i> */}
                        </label>
                        <textarea type="text" className="resume_input_field resume_textarea" name="projects" autoComplete='off'
                        value={user.projects}
                        onChange={handleInputs}
                        placeholder='Enter you projects details in brief'/>
                    </div>

                    <div className="form_group">
                        <label htmlFor="skills">
                            {/* <i class="zmdi zmdi-lock"></i> */}
                        </label>
                        <textarea type="text" className="resume_input_field resume_textarea" name="skills" autoComplete='off'
                        value={user.skills}
                        onChange={handleInputs}
                        placeholder='Enter you skills details in brief'/>
                    </div>

                    <div className="form_group">
                        <label htmlFor="education">
                            {/* <i class="zmdi zmdi-lock"></i> */}
                        </label>
                        <textarea type="text" className="resume_input_field resume_textarea" name="education" autoComplete='off'
                        value={user.education}
                        onChange={handleInputs}
                        placeholder='Enter your educational details'/>
                    </div>


                    <div className="form_group">
                        <label htmlFor="others">
                            {/* <i class="zmdi zmdi-lock"></i> */}
                        </label>
                        <textarea type="text" className="resume_input_field resume_textarea" name="others" autoComplete='off'
                        value={user.others}
                        onChange={handleInputs}
                        placeholder='Enter any other details you want to add on'/>
                    </div>





                    <div className='reg_button'>
                    <input type="submit" name="signup" id = "signup" className='form_submit'
                     value="Register" onClick={PostData}/>
                     
                    </div>
                    



                </form>

                        </div>
                    </div>
                </div>
            </div>

            <div className="resume_price">
                <div className="resume_image_price_box">
                    <img className="resume_form_img" src="image/Resume/Resume_price_img.webp" alt="" />
                </div>
            </div>
        </div>

        <AutoplaySwi
            img1="image/Resume/Evaluation_swiper/1.webp"
            img2="image/Resume/Evaluation_swiper/2.webp"
            img3="image/Resume/Evaluation_swiper/3.webp"
            img4="image/Resume/Evaluation_swiper/4.webp"
            img5="image/Resume/Evaluation_swiper/5.webp"
            img6="image/Resume/Evaluation_swiper/6.webp"
        
        />



    
    
    </>
  )
}

export default Resume